/**
 * @flow
 * @author: Prasanth
 */

export const MOBILE_NUMBER_MAX_LENGTH = 10
export const OTP_MAX_LENGTH = 10
export const DEFAULT_LANGUAGE_CODE = 'en'
